module.exports = __webpack_public_path__ + "assets/img/ds7.6659768d.jpg";